

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/privacy/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.455c4284.js","_app/immutable/chunks/scheduler.b6a01382.js","_app/immutable/chunks/index.a3f59a79.js","_app/immutable/chunks/Loading.b07dc5e3.js","_app/immutable/chunks/index.a2248096.js"];
export const stylesheets = ["_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
